import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  userRouter: Array<RouteRecordRaw> = [
    {
        path: '/user',
        name: '用户管理',
        component: Layout,
        meta: { title: '用户管理', icon: 'icon-lock', alwaysShow: true },
        children: [
            {
                path: 'comment',
                name: '评论管理',
                component: () => import('@/views/user/Comment.vue'),
                meta: { title: '评论管理' }
            },
            {
                path: 'user-list',
                name: '用户',
                component: () => import('@/views/user/UserList.vue'),
                meta: { title: '用户', keepAlive: true, depth: 30 }
            },
            {
                path: 'user-show',
                name: '用户详情-查看',
                component: () => import('@/views/user/UserDetail.vue'),
                meta: { title: '用户详情' }
            },
            {
                path: 'user-edit',
                name: '用户详情-编辑',
                component: () => import('@/views/user/UserDetail.vue'),
                meta: { title: '用户详情' }
            },
            {
                path: 'user-card',
                name: '用户卡包',
                component: () => import('@/views/user/UserCard.vue'),
                meta: { title: '用户卡包',depth: 40 }
            },
            {
                path: 'user-log',
                name: '用户余额日志',
                component: () => import('@/views/user/UserLog.vue'),
                meta: { title: '用户余额日志',depth: 40 }
            },
            {
                path: 'edit-money',
                name: '修改余额',
                component: () => import('@/views/user/EditMoney.vue'),
                meta: { title: '修改余额',depth: 40 }
            },
            {
                path: 'balance',
                name: '余额管理',
                component: () => import('@/views/user/Balance.vue'),
                meta: { title: '余额管理' }
            },
            {
                path: 'help-order',
                name: '用户帮订',
                component: () => import('@/views/user/HelpOrder.vue'),
                meta: { title: '用户帮订' } 
            },
            {
                path: 'scalper-user',
                name: '黄牛用户',
                component: () => import('@/views/order/ScalperUser.vue'),
                meta: { title: '黄牛用户', badge: 'rule_auths' }
            },
            {
                path: 'scalper-list',
                name: '黄牛用户列表',
                component: () => import('@/views/user/ScalperList.vue'),
                meta: { title: '黄牛用户' }
            },
            {
                path: 'user-order',
                name: '用户订单列表',
                component: () => import('@/views/user/UserOrder.vue'),
                meta: { title: '用户订单列表' }
            },
        ]
    }
]

export default  userRouter